module.exports = __webpack_public_path__ + "assets/img/btn-view-0b92e631.png";